// extracted by mini-css-extract-plugin
export default {"title":"FailedToLoad_title__s4DA9","message":"FailedToLoad_message__8pxfj"};